import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana59Div2M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_25822)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("1"))}
        d="M783.478 433.203L756.572 408.859L721.112 421.134L736.115 466.141L777.03 452.502C785.527 450.614 786.467 442.463 785.683 437.061C785.463 435.549 784.611 434.228 783.478 433.203Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M719.733 373.397L756.557 408.857L697.912 427.951L684.273 385.672L719.733 373.397Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M691.096 481.141L736.103 466.139L721.1 421.132L674.729 436.134L691.096 481.141Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M635.183 403.404L684.281 385.674L697.92 427.953L648.821 445.683L635.183 403.404Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M644.726 498.873L691.096 481.143L674.73 436.136L628.359 453.866L644.726 498.873Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M588.808 419.768L635.178 403.401L648.817 445.681L603.81 463.411L588.808 419.768Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M599.716 516.6L644.723 498.87L628.357 453.863L583.35 471.593L599.716 516.6Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M541.08 438.864L588.815 419.771L603.817 463.414L558.81 481.144L541.08 438.864Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M554.711 534.334L599.718 516.604L583.352 471.597L538.345 489.327L554.711 534.334Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M494.71 456.589L541.081 438.859L558.811 481.139L511.076 500.232L494.71 456.589Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M509.704 552.06L554.711 534.33L538.344 489.323L491.974 508.417L509.704 552.06Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M446.969 475.688L494.703 456.594L511.069 498.873L463.335 519.331L446.969 475.688Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M464.699 569.793L509.706 552.063L491.976 507.056L446.969 526.149L464.699 569.793Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M400.597 494.779L446.967 475.686L463.334 517.965L419.691 537.059L400.597 494.779Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M419.7 588.885L464.707 569.791L446.977 526.148L401.97 545.242L419.7 588.885Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M354.227 515.24L400.597 494.782L418.327 537.061L371.957 556.155L354.227 515.24Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M374.683 607.98L419.69 588.886L401.96 543.879L355.589 562.973L374.683 607.98Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M307.855 534.33L354.226 515.236L371.956 556.152L324.222 576.609L307.855 534.33Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M329.688 628.436L374.694 607.979L355.601 562.972L310.594 582.066L329.688 628.436Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M286.044 647.532L329.687 628.438L310.593 582.067L265.586 602.525L286.044 647.532Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M242.4 667.988L286.043 647.53L265.585 602.523L220.578 622.981L242.4 667.988Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M262.851 554.79L307.857 534.332L324.224 576.611L279.217 595.705L262.851 554.79Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        d="M213.756 575.248L262.854 554.79L279.22 595.705L232.85 617.527L213.756 575.248Z"
        fill="#0096B3"
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_25822"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_25822"
            transform="matrix(0.00187074 0 0 0.0024801 -2.92793 -1.58092)"
          />
        </pattern>
        <image
          id="image0_1466_25822"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
